import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { createStore } from 'redux';

import './index.css';
import Index from './pages/Index';
import Animation from './pages/Animation/Animation';
import P404 from './pages/404';
import * as serviceWorker from './serviceWorker';

// eslint-disable-next-line no-console
const store = createStore(() => console.log('replace with combined reducer'));

// fix the router for prod
const URL_BASE = process.env.NODE_ENV === 'dev' ? '/csses/' : '/';

ReactDOM.render(
  <Provider store={store}>
    <HashRouter basename="/#">
      <Switch>
        <Route exact path={URL_BASE} component={Animation} />
        {/* <Route exact path={URL_BASE} component={Index} /> */}
        <Route component={P404} />
      </Switch>
    </HashRouter>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
